import { Component, OnDestroy,ViewChild, ElementRef, OnInit,ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subject, Observable } from 'rxjs';
import { takeUntil, startWith, map } from 'rxjs/operators';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { LoginService } from "../../../../providers/login.provider";
import { Router, ActivatedRoute } from '@angular/router';
import { ResourcesProvider } from 'app/providers/resources.provider';
import { AppConfigService } from 'app/providers/data/app-config.service';
import { HttpClient } from '@angular/common/http';

@Component({
    selector     : 'register-2',
    templateUrl  : './register-2.component.html',
    styleUrls    : ['./register-2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class Register2Component implements OnInit, OnDestroy
{
    registerForm: FormGroup;
    termNotChecked: boolean = false;
    privacityNotChecked: boolean = false;
    notLengthPass: boolean = false;
    errorMsjRegister: string = '';
    isLoading: boolean = false;
    isAuthority: boolean = false;
    isAdvisorCitizen: boolean = false;
    textBtnUpload   :String = "Elegir archivo PDF";
    txtErrorFile    :String = 'Debes adjuntar este documento en formato PDF, es obligatorio'  
    txtErrorFiledaut :String = '';
    txtErrorFileine :String = '';
    municipalities: any = [];
    nameList: any = [];
    filteredOptions: Observable<Array<any>>;
    typeUs: any = [];
    // Private
    private _unsubscribeAll: Subject<any>;
    @ViewChild('ine') ine:ElementRef;
    @ViewChild('nombramiento') nombramiento:ElementRef;

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _loginService: LoginService,
        private _activatedRoute: ActivatedRoute,
        private _resourceService: ResourcesProvider,
        private _settings: AppConfigService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private cdRef:ChangeDetectorRef
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.typeUs = [
            {nume: 1, name: 'Parte Actora / Tercero Perjudicado'},
            {nume: 2, name: 'Autoridad'},
       
        ]
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        
        this._validTypeRegister();
        this.registerForm = this.getRegisterForm();
        // Update the validity of the 'passwordConfirm' field
        // when the 'password' field changes
        this.registerForm.get('password').valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                if(this.registerForm.get('passwordConfirm')){
                    this.registerForm.get('passwordConfirm').updateValueAndValidity();
                }
            });
    }

    _validTypeRegister() {
        //const typeRegister    = this._activatedRoute.snapshot.params.typeRegister;
        this._getMunicipalities();
        /*if(typeRegister === 'authority') {
            //this._loginFakeUser();
            this.isAuthority = true;
        }
        if(typeRegister === 'advisor-citizen') {
            this.isAdvisorCitizen = true;
        }*/  
    }

    getRegisterForm() {
        return this._formBuilder.group({
            tUs: ['', Validators. required],
            tp: [''],
            name                 : ['', Validators.required],
            paterno              : ['', Validators.required],
            materno              : ['', Validators.required],
            // @Andre, se agrega campo de curp e ine
            ine                  :['',Validators.required],
            nombramiento         : [''],
            curp                 : [''],
            folio                 : [''],
            telefono             : ['', [Validators.minLength(10), Validators.pattern('[0-9]*')]],   
            email                : ['', [Validators.required, Validators.email]],
            email_confirmation   : [''],
            //DATOS AUTORIDAD
            auto                 : ['',],
            muni                 : ['',],
            tpau                 : ['',],

            password             : ['', [Validators.required, confirmPasswordValidator, Validators.minLength(6)]],
            password_confirmation: ['', [Validators.required, confirmPasswordValidator, Validators.minLength(6)]],
            terms                : [''],
            privacity            : ['', Validators.requiredTrue]
        });
    }

    consoleForm(){
        console.log("formulario",this.registerForm);
    }

    setType(data){
        this.registerForm.get('tp').setValue(data);
        
        if(data == 1){
            this.registerForm.get('curp').setValidators([Validators.required]);
            this.registerForm.get('auto').setValidators([]);
            this.registerForm.get('muni').setValidators([]);
            this.registerForm.get('tpau').setValidators([]);
        }else if(data == 2){
            this.registerForm.get('curp').setValidators([Validators.required]);
            this.registerForm.get('nombramiento').setValidators([Validators.required]);
            this.registerForm.get('folio').setValidators([Validators.required]);
            this.registerForm.get('auto').setValidators([Validators.required]);
            this.registerForm.get('muni').setValidators([Validators.required]);
            this.registerForm.get('tpau').setValidators([Validators.required]);
        }else if(data == 3){
            this.registerForm.get('curp').setValidators([]);
            this.registerForm.get('auto').setValidators([]);
            this.registerForm.get('muni').setValidators([]);
            this.registerForm.get('tpau').setValidators([]);
        }
        this.cdRef.detectChanges();
    }

    onSubmit() {
        console.log("form debug",this.registerForm.value);
        this.errorMsjRegister = '';
        this.isLoading = true;
        if (this.registerForm.valid) {
            this._loginService.registerUser(this.registerForm.value).subscribe(
                (res)=> {
                    //this.isLoading = false;
                    console.log(res)
                    this._onSuccessRegister(res);
                },
                (error) => {
                    this.isLoading = false;
                    this.errorMsjRegister  = this._settings._getMsjError(error);
                }
            )
        }
    }

    _onSuccessRegister(result) {
        if(this.isAdvisorCitizen){
            const user = result['data'];
            const save_user = this._settings.toEncrypt(JSON.stringify(user));
            sessionStorage.setItem('usr', save_user.toString());
            this._loginUser();
        }else {
            this.isLoading = false;
            this.router.navigate(['pages/auth/mail-confirm'])  
        }
    }

    _loginUser(){
        const loginForm = {
            email   : this.registerForm.value.email,
            password: this.registerForm.value.password,
            clav    : false
        }
        this._loginService.getTokenLogin(loginForm).subscribe(
            (res) => {
                this.isLoading = false;
                sessionStorage.setItem('tk', (res['data'] !== null) ? res['data'].access_token : null);
                this.router.navigate(['/pages/auth/adviser-citizen-form'])
            },
            (error) => {
                console.log(error);
                this.errorMsjRegister = this._settings._getMsjError(error);
                this.isLoading = false;
            });
    }

    _loginFakeUser(){
        const loginForm = {
            email   : 'titida2292@teeshirtsprint.com',
            password: 'vacagorda123',
            clav    : false
        }
        this._loginService.getTokenLogin(loginForm).subscribe(
            (res) => {
                //this.isLoading = false;
                sessionStorage.setItem('tk', (res['data'] !== null) ? res['data'].access_token : null);
                this._getMunicipalities();
            },
            (error) => {
                this._getMunicipalities();
                //this.errorMsjRegister = this._settings._getMsjError(error);
               // this.isLoading = false;
            });
    }

    _getMunicipalities() {
        this._resourceService.getMunicipalities().subscribe(
            (result) => this.municipalities = result['data'],
            (error) => console.log('error get municipalities')
        );
    }

    _filterNames(){
        this.filteredOptions = this.registerForm.get('auto').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value.name),
                map(name => name ? this._filter(name) : this.nameList.slice())
            );
    }

    _getNamesList() {
        const muni = this.registerForm.value.muni, 
                type = this.registerForm.value.tpau
        if(muni !== '' && type !== '') {
            this._resourceService.getNamesRegister(muni, type).subscribe(
                (result) => {
                    console.log(result['data'])
                    this.nameList = result['data']
                },
                (error) => console.log('error get names')
            );
        }
    }

    displayFn(user: any): string {
        return user && user.name ? user.name : '';
    }
    
    private _filter(name: string): any[] {
        const filterValue = name.toLowerCase();
    
        return this.nameList.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    validTermsChecked = () => {
        this.termNotChecked = !this.registerForm.value.terms;
    }

    validPrivacityChecked = () => {
        this.privacityNotChecked = !this.registerForm.value.privacity;
    }

    validLength(param: String): Boolean{
        if (param.length < 6) {
            this.notLengthPass = true;
            return false
        }        
        this.notLengthPass = false;
        return true
    }

    setFile(inputFileName) {
        const inputFileName2 = inputFileName;
        const reader = new FileReader();
        const fileUpload = this[`${ inputFileName }`].nativeElement;
        fileUpload.onchange = () => {   
          if(fileUpload.files && fileUpload.files.length) {
            const [file] = fileUpload.files;
            inputFileName = file.name;
            if(!this.validTypeSizeFile(file, inputFileName)) {
              return
            }
            reader.readAsDataURL(file);
            reader.onload = () => {
              this.registerForm.patchValue({
                [`${ inputFileName2 }`]: file
              });
            };
            // console.log(inputFileName);
            this.cd.markForCheck();
          }
        };
        fileUpload.click();  
      }
    
      validTypeSizeFile(file, inputFileName) {
        this.txtErrorFiledaut = '';
        if(inputFileName === 'ine' || inputFileName === 'nombramiento'){
          this.txtErrorFileine = this.txtErrorFile;
        }
        if(file.type !== 'application/pdf') {
          this[`txtErrorFile${ inputFileName }`] = 'El archivo debe ser en formato PDF';
          return false;
        }
        if(file.size > 10000000) {
          this[`txtErrorFile${ inputFileName }`] = 'El archivo debe ser de un tamaño no mayor a 10mb';
          return false;
        }
        return true;
      }
    
      removeFile(inputFileName){
        this.registerForm.patchValue({
          [`${ inputFileName }`]: ''
        });
      }
    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}

/**
 * Confirm password validator
 *
 * @param {AbstractControl} control
 * @returns {ValidationErrors | null}
 */
export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if ( !control.parent || !control )
    {
        return null;
    }

    const password = control.parent.get('password');
    const passwordConfirm = control.parent.get('password_confirmation');

    if ( !password || !passwordConfirm )
    {
        return null;
    }

    if ( passwordConfirm.value === '' )
    {
        return null;
    }

    if ( password.value === passwordConfirm.value )
    {
        return null;
    }

    return {passwordsNotMatching: true};
};

/**
 * Confirm password validator
 *
 * @param {AbstractControl} control
 * @returns {ValidationErrors | null}
 */
export const confirmEmailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if ( !control.parent || !control )
    {
        return null;
    }

    const email = control.parent.get('email');
    const emailConfirm = control.parent.get('email_confirmation');

    if ( !email || !emailConfirm )
    {
        return null;
    }

    if ( emailConfirm.value === '' )
    {
        return null;
    }

    if ( email.value === emailConfirm.value )
    {
        return null;
    }

    return {emailsNotMatching: true};
};
